import { SignalNotificationOption } from 'src/graphql/entities/user-communication-preferences';

export enum UpdateUserFormFields {
  Id = 'id',
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  AvatarFileKey = 'avatarFileKey',
  PrimaryNotificationChannel = 'primaryNotificationChannel',
  SecondaryNotificationChannel = 'secondaryNotificationChannel',
  TertiaryNotificationChannel = 'tertiaryNotificationChannel',
}

export type UpdateUserFormModel = {
  [UpdateUserFormFields.Id]: string;
  [UpdateUserFormFields.FirstName]: string;
  [UpdateUserFormFields.LastName]: string;
  [UpdateUserFormFields.Email]: string;
  [UpdateUserFormFields.PhoneNumber]: string;
  [UpdateUserFormFields.AvatarFileKey]: string | null;
  [UpdateUserFormFields.PrimaryNotificationChannel]: SignalNotificationOption | null;
  [UpdateUserFormFields.SecondaryNotificationChannel]: SignalNotificationOption | null;
  [UpdateUserFormFields.TertiaryNotificationChannel]: SignalNotificationOption | null;
};
